import { Component, Input, SimpleChanges, OnChanges , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { subYears } from 'date-fns';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
    selector: 'app-user-personal-information',
    templateUrl: './user-personal-information.component.html',
    styleUrls: ['./user-personal-information.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, MatDatepickerModule, MatNativeDateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class UserPersonalInformationComponent implements OnChanges {
    constructor() {}

    @Input() content: any;
    @Input() profileForm: FormGroup;
    @Input() profileFormData: any;

    maxDate = subYears(new Date(), 18);
    //phoneCountry: string;

    phoneCountry: any = {
        //for modal
        display: false, //to manage display on/off modal
        selectedflaginput: '', //to display selected flag second time open modal
        emititemtext: '',

        //for textbox
        valueInputInitial: '',
        //valueInputInitial: string = "+919876543210";
        emititemmodal: '',
    };

    altPhoneCountry: any = {
        //for modal
        display: false, //to manage display on/off modal
        selectedflaginput: '', //to display selected flag second time open modal
        emititemtext: '',

        //for textbox
        valueInputInitial: '',
        //valueInputInitial: string = "+919876543210";
        emititemmodal: '',
    };

    libphonenumbervalid: boolean = null;

    trackByIndex = (index: number): number => index;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.profileFormData) {
            let change = changes.profileFormData.currentValue;
            if (change) {
                //this.phoneCountry = change.phone;
                this.phoneCountry.valueInputInitial = change.phone;
                this.altPhoneCountry.valueInputInitial = change.altphone;
            }
        }
    }

    //listen from both text and modal
    listenerPhoneTextAndModel(ev: CustomEvent, control: string) {
        const phoneConfig = control === 'phone' ? this.phoneCountry : control === 'altphone' ? this.altPhoneCountry : false;
        const event = ev.detail;

        if (phoneConfig) {
            //from modal
            if (event.actionType && event.actionType == 'modalDisplay') {
                phoneConfig.display = event.value.display;
            }

            //from modal
            if (event.actionType && event.actionType == 'onChangeModal') {
                phoneConfig.selectedflaginput = event.value;
                phoneConfig.emititemmodal = event.value;
                if (event) {
                    if (event.value) {
                        this.profileForm.patchValue({
                            [control]: event.value.concatinated,
                        });
                        this.profileForm.controls[control].markAsTouched();
                    }
                }
            }

            //from textbox
            if (event.actionType && event.actionType == 'onChange') {
                phoneConfig.emititemtext = event.value;
                if (event) {
                    if (event.value) {
                        this.profileForm.patchValue({
                            [control]: event.value.concatinated,
                        });
                        this.profileForm.controls[control].markAsTouched();
                    }
                }
            }

            if (control === 'phone') {
                this.libphonenumbervalid = event.value.valid;
            }
        } else {
            return;
        }
    }

    noOfDigitsCheck(phone: string) {
        if (phone) {
            const regexDigits = /[0-9]+/g;
            const phoneRegex = regexDigits[Symbol.match](phone);
            const phoneValue = phoneRegex.join('');
            if (phoneValue && phoneValue.length >= 7) {
                return true;
            }
            return false;
        }
        return false;
    }
}
